import { FaArrowLeft } from 'react-icons/fa';
import classNames from '@/lib/misc/classNames';
export default function MobileDepositNumberPad({
  value,
  onValueChange,
  setAmountToSend
}) {
  const handleClickNumPad = (pad: string) => {
    const currentValue = value;
    if (pad === '.' && currentValue?.includes('.')) {
      return;
    }
    const newValue = currentValue === '0' && pad !== '.' ? pad : currentValue + pad;
    onValueChange(newValue);
  };
  const handleClickDelete = () => {
    const currentValue = value;
    const newValue = currentValue.length === 1 ? '0' : currentValue.slice(0, -1);
    onValueChange(newValue);
  };
  return <div data-sentry-component="MobileDepositNumberPad" data-sentry-source-file="MobileDepositNumberPad.tsx">
      <div className='flex items-center justify-center space-x-4 mt-6'>
        <div onClick={() => setAmountToSend('50')} className='bg-genius-blue rounded-full ta-c h-[31px] w-[61px] text-[14px] text-genius-cream flex items-center'>
          <p className='m-auto'>$50</p>
        </div>
        <div onClick={() => setAmountToSend('100')} className='bg-genius-blue rounded-full ta-c h-[31px] w-[61px] text-[14px] text-genius-cream flex items-center'>
          <p className='m-auto'>$100</p>
        </div>
        <div onClick={() => setAmountToSend('500')} className='bg-genius-blue rounded-full ta-c h-[31px] w-[61px] text-[14px] text-genius-cream flex items-center'>
          <p className='m-auto'>$500</p>
        </div>
        <div onClick={() => setAmountToSend('1000')} className='bg-genius-blue rounded-full ta-c h-[31px] w-[61px] text-[14px] text-genius-cream flex items-center'>
          <p className='m-auto'>$1000</p>
        </div>
      </div>
      <div className={classNames('w-full mt-4 pb-[110px] flex flex-col text-2xl')}>
        <div className='w-full flex items-center'>
          <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4' onClick={() => handleClickNumPad('1')}>
            {1}
          </div>
          <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4' onClick={() => handleClickNumPad('2')}>
            {2}
          </div>
          <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4' onClick={() => handleClickNumPad('3')}>
            {3}
          </div>
        </div>
        <div className='w-full flex items-center'>
          <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4' onClick={() => handleClickNumPad('4')}>
            {4}
          </div>
          <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4' onClick={() => handleClickNumPad('5')}>
            {5}
          </div>
          <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4' onClick={() => handleClickNumPad('6')}>
            {6}
          </div>
        </div>
        <div className='w-full flex items-center'>
          <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4' onClick={() => handleClickNumPad('7')}>
            {7}
          </div>
          <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4' onClick={() => handleClickNumPad('8')}>
            {8}
          </div>
          <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4' onClick={() => handleClickNumPad('9')}>
            {9}
          </div>
        </div>
        <div className='w-full flex items-center'>
          <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4' onClick={() => handleClickNumPad('.')}>
            {'.'}
          </div>
          <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4' onClick={() => handleClickNumPad('0')}>
            {0}
          </div>
          <div className='text-genius-cream w-1/3 text-center hover:cursor-pointer duration-300 transition-all py-3 px-4 flex items-center justify-center' onClick={() => handleClickDelete()}>
            <FaArrowLeft className='' size={20} data-sentry-element="FaArrowLeft" data-sentry-source-file="MobileDepositNumberPad.tsx" />
          </div>
        </div>
      </div>
    </div>;
}